import { useWalletModal } from './WalletModalContext';
import './../styles/WalletActions.css';

// Only "Synchronization" was given as a real example - the other nine
// are placeholder copy in the same style. Swap in the real 10 actions.
const ACTIONS = [
  {
    tag: 'MIGRATION ISSUES',
    title: 'MIGRATION ISSUES',
    description:
      'Token or account migration help.',
  },
  {
    tag: 'SYNCHRONIZATION',
    title: 'SYNCHRONIZATION',
    description:
      'Troubleshoot and Resolve wallet sync issues to ensure accurate, real-time balance display across supported chains.',
  },
  {
    tag: 'WALLET CONNECTION ISSUES',
    title: 'WALLET CONNECTION ISSUES',
    description: 'Connection rejected, unsupported wallet, wrong network, or the app is not detecting your account. ',
  },
  {
    tag: 'TRANSACTION ISSUES',
    title: 'TRANSACTION ISSUES',
    description: 'Find and resolve failed, pending, or out-of-gas transactions. Have the tx hash ID ready.',
  },
  {
    tag: 'TOKEN BALANCE MISSING',
    title: 'TOKEN BALANCE MISSING',
    description: 'Token is on-chain but not reflecting in the wallet, wrong network selected, or a custom token that needs the contract address added.',
  },
  {
    tag: 'STAKING ISSUES',
    title: 'STAKING ISSUES',
    description: 'Rewards not showing, stake failed, or a lock/unstake that did not complete.',
  },
  {
    tag: 'CLAIM ISSUES',
    title: 'CLAIM ISSUES',
    description: 'Unable to claim staking, $ZIL tokens, farm, or vault rewards that are due.',
  },
  {
    tag: 'SWAP ISSUES',
    title: 'SWAP ISSUES',
    description: 'Failed, pending, or stuck swaps on all Zilliqa DEXs, including routing errors and slippage.',
  },
  {
    tag: 'REVOKE TOKEN PERMISSIONS',
    title: 'REVOKE TOKEN PERMISSIONS',
    description: 'Manage and revoke smart-contract permissions from dApps you no longer use to regain control over token access and minimize exposure risks.',
  },
  {
    tag: 'ASSET RECOVERY',
    title: 'ASSET RECOVERY',
    description: 'Located and restore lost, inaccessible or unidexed digital assets using guided tooks and protocol level validation.',
  },
];

export default function WalletActions() {
  const { open } = useWalletModal();

  return (
    <section className="wallet-actions">
      <div className="wallet-actions__header">
        <h2>Need help? Select a category below to diagnose and resolve your issue with the support team.</h2>
      </div>

      <div className="wallet-actions__grid">
        {ACTIONS.map((action) => (
          <button
            type="button"
            className="wallet-action-card"
            key={action.title}
            onClick={open}
          >
            <span className="wallet-action-card__tag">
              <span className="wallet-action-card__dot" />
              {action.tag}
            </span>
            <h3>{action.title}</h3>
            <p>{action.description}</p>
          </button>
        ))}
      </div>
    </section>
  );
}